import React from 'react';
import icon1 from '../assets/rfq_icon.webp';
import icon2 from '../assets/clob_icon.webp';
import icon3 from '../assets/auction_icon.webp';
import icon4 from '../assets/list_portfolio_icon.webp';
import spotlightIcon from '../assets/spotlight_icon.webp';

const EveryProtocolOneSystem = () => {
    const cards = [
        {
            id: 'rfq',
            title: 'RFQ',
            description:
                'A Trader can initiate an RFQ or requests quotes from specific dealers with back-and-forth negotiation and "last look" confirmation or Firm. We support all variations supported by respective ECN.',
            offsetClass: 'translate-x-0 rotate-[0.4deg] z-40',
            icon: icon1,
        },
        {
            id: 'quotes-orders',
            title: 'Quotes & Orders',
            description:
                'An order or a Quote where the best bid matches the best offer — for an immediate, automatic execution, or on the basis of "last look" as applicable.',
            offsetClass: 'translate-x-2 -mt-6 rotate-[0.3deg] z-30',
            icon: icon2,
        },
        {
            id: 'auction',
            title: 'Auction',
            description:
                'A time-based session on an ECN to concentrate liquidity for a specific set of securities with price discovery, pre-match, match, negotiations and workup windows.',
            offsetClass: 'translate-x-0 -mt-6 rotate-[-0.1deg] z-20',
            icon: icon3,
        },
        {
            id: 'list-portfolio',
            title: 'List / Portfolio',
            description:
                'Trade a bundle of securities as a single list or a portfolio — all-or-none or partial fills. A rapidly growing trend in fixed income.',
            offsetClass: 'translate-x-2 -mt-6 rotate-[0.1deg] z-10',
            icon: icon4,
        },
    ];

    return (
        <section className="w-full bg-[#091026] py-14 lg:py-24 text-white">
            <div className="site-shell">
                <div className="flex flex-col xl:flex-row gap-10 xl:gap-12 items-start">
                    <div className="w-full xl:basis-[30%] xl:max-w-none xl:flex-none">
                        <h2 className="font-oswald text-4xl md:text-[48px] font-bold uppercase leading-[1.05]">
                            <span className="block text-[#00C2FF]">FIXED INCOME TRADING -</span>
                            <span className="block">EVERY PROTOCOL</span>
                            <span className="block">EVERY ECN</span>
                            <span className="inline-flex items-center gap-2 md:gap-3">
                                <span>ONE SYSTEM</span>
                                <img
                                    src={spotlightIcon}
                                    alt=""
                                    aria-hidden="true"
                                    className="h-auto w-[34px] md:w-[44px] lg:w-[52px] shrink-0 -translate-x-1 md:-translate-x-1.5"
                                />
                            </span>
                        </h2>
                        <p className="font-inter text-base md:text-[18px] text-white mt-4 leading-[1.5]">
                            FGC TMS supports all major trading protocols used in fixed income markets, such as Quotes, Orders, Negotiated RFQs, and List and portfolio trading, across all ECNs.
                        </p>
                    </div>

                    <div className="w-full xl:basis-[65%] xl:flex-none">
                        <div className="relative flex flex-col gap-3 lg:gap-2.5">
                            {cards.map((card) => (
                                <div
                                    key={card.id}
                                    className={`relative bg-white text-[#0E0E0E] rounded-[16px] border border-[rgba(14,14,14,0.2)] shadow-[3px_4px_17px_0px_rgba(0,0,0,0.1)] p-[14px] lg:p-[12px] ${card.offsetClass}`}
                                >
                                    <div className="flex flex-col gap-3 lg:gap-2">
                                        <div className="w-[28px] h-[28px] lg:w-[24px] lg:h-[24px]">
                                            <img src={card.icon} alt={`${card.title} Icon`} className="w-full h-full" loading="lazy" />
                                        </div>
                                        <div className="flex flex-col gap-2 lg:gap-1.5">
                                            <h3 className="font-inter text-[22px] lg:text-[20px] font-bold leading-[1.2]">
                                                {card.title}
                                            </h3>
                                            <p className="font-inter text-[16px] lg:text-[14px] font-normal text-[#0e0e0e] leading-[1.45]">
                                                {card.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EveryProtocolOneSystem;
